import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { getClassName, getValue } from "../../../../components/Converter";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { decimalSeparator, thousandSeparator } from "../../../../i18n";
import { selectFactorOfSafety, setFactorOfSafety } from "../../../../store/slices/fhwaSlice";

function FactorOfSafety() {
  const dispatch = useDispatch();
  const { t } = useTranslation("translation");

  const factorOfSafety = useSelector(selectFactorOfSafety);

  return (
    <>
      <RowBody
        titleValue={<p>{t("aashto.inner.factorOfSafety")}</p>}
        inputValue={
          <NumberFormat
            decimalScale={2}
            className={getClassName(factorOfSafety)}
            value={getValue(factorOfSafety)}
            decimalSeparator={decimalSeparator()}
            thousandSeparator={thousandSeparator()}
            displayType="input"
            type="text"
            allowNegative={false}
            onValueChange={(value) => {
              dispatch(setFactorOfSafety(value.floatValue));
            }}
          />
        }
      />
    </>
  );
}

export default FactorOfSafety;
